module.exports = __webpack_public_path__ + "img/電気回路_5_7_3.560de25b.png";